import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextColor,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AnyLogMessage } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpp/src/logger/ocpp-logs-messsages.interface';
import { useTranslation } from 'react-i18next';

import { useLogCardContext } from '@app/feature/charge-point/charge-point-details/tabs/maintenance-tab/log-card/log-card.context';

import * as css from './log-item.module.scss';

interface LogItemWrapperProps {
  children: React.ReactNode;
  call: AnyLogMessage;
}

export const LogItemWrapper = ({
  children,
  call,
}: LogItemWrapperProps): React.JSX.Element => {
  const { t } = useTranslation();

  const { isExpertMode } = useLogCardContext();

  return (
    <Stack direction="column" gap={GapEnum.M}>
      {isExpertMode && (
        <>
          <Text
            color={TextColor.Secondary}
            className={css.title}
            fontSize={TextFontSize.Small}>
            {t('$.charge-point-details.maintenance.log.call.title')}
          </Text>
          <pre>
            <code>{JSON.stringify(call, null, 2)}</code>
          </pre>
        </>
      )}
      <Text
        color={TextColor.Secondary}
        className={css.title}
        fontSize={TextFontSize.Small}>
        {t('$.charge-point-details.maintenance.log.call-response.title')}
      </Text>
      {children}
    </Stack>
  );
};
